import { THEME_FRAME_FIELDS } from './frame';
import { THEME_FOOTER_FIELDS } from './footer';
import { THEME_HEADER_FIELDS } from './header';
import { THEME_PRODUCT_CARD_FIELDS } from './product-card';
import { THEME_STYLE_FIELDS } from './style';
export * from './fonts';
export * from './frame';
export * from './header';
export * from './footer';
export * from './product-card';
export * from './style';
export const THEME_PARTS = {
    style: {
        label: 'Estilo',
        help: 'Cores, fontes, cantos e botões da loja inteira, inclusive carrinho e pagamento.',
        fields: THEME_STYLE_FIELDS,
    },
    frame: {
        label: 'Moldura da página',
        help: 'Largura do conteúdo e onde ficam as categorias e a barra lateral.',
        fields: THEME_FRAME_FIELDS,
    },
    header: {
        label: 'Cabeçalho',
        help: 'Logo, busca, barra de aviso e o cabeçalho transparente sobre o banner.',
        fields: THEME_HEADER_FIELDS,
    },
    footer: {
        label: 'Rodapé',
        help: 'Blocos, fundo, faixa de benefícios, dados da empresa e botões flutuantes.',
        fields: THEME_FOOTER_FIELDS,
    },
    productCard: {
        label: 'Card de produto',
        help: 'O mesmo card em toda listagem: vitrines, coleções, busca, relacionados e favoritos.',
        fields: THEME_PRODUCT_CARD_FIELDS,
    },
};
export const THEME_PART_KEYS = Object.keys(THEME_PARTS);
/**
 * Campos de uma parte com os padrões do tema: o esquema comum, e o valor padrão de
 * cada campo trocado pelo que o manifesto escolheu.
 */
export function themePartFields(manifest, part) {
    const presets = manifest.parts?.[part] ?? {};
    const fields = {};
    for (const [key, field] of Object.entries(THEME_PARTS[part].fields)) {
        fields[key] = key in presets ? { ...field, default: presets[key] } : field;
    }
    return fields;
}
//# sourceMappingURL=index.js.map